// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"settingsPage__gradient-bg5__nPzX2","section":"settingsPage__section__UiCzL"};